export default {"src":"/_next/static/media/arrow_down.b32755cb.gif","height":450,"width":360,"blurWidth":0,"blurHeight":0};